import React from 'react'

function Share ({ className, fill }) {
  return (
    <svg fill={fill} className={className} height="512pt" viewBox="0 0 512 512" width="512pt"
         xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,511.642578125,0.3574218749999716)">
        <path xmlns="http://www.w3.org/2000/svg"
              d="m511.285156 94.230469-94.234375-94.230469-94.230469 94.230469 28.269532 28.269531 45.972656-45.972656v80.640625c0 29.152343-12.632812 56.824219-34.660156 75.917969l-78.296875 67.875c-11.40625 9.886718-21.015625 21.351562-28.628907 33.894531-7.457031-12.597657-16.894531-24.011719-28.101562-33.722657l-78.492188-68.046874c-22.027343-19.09375-34.664062-46.765626-34.664062-75.917969v-80.640625l45.976562 45.972656 28.269532-28.269531-94.234375-94.230469-94.230469 94.230469 28.269531 28.269531 45.972657-45.972656v80.640625c0 40.753906 17.660156 79.433593 48.453124 106.128906l78.492188 68.042969c21.480469 18.621094 33.859375 46.160156 33.964844 75.488281v105.171875h39.976562v-104.914062c0-28.875 12.816406-56.546876 35.164063-75.917969l78.296875-67.871094c30.792968-26.695313 48.449218-65.375 48.449218-106.128906v-80.640625l45.976563 45.972656zm0 0"/>
      </g>
    </svg>
  )
}

Share.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Share
